// NOTE: NewRelic could be enabled here however it breaks playback on both Ziggo and KPN therefore it's commented out
// NOTE: these global patches must stay first so they are installed before any module that relies on
// them at evaluation time (e.g. the typography dictionary) is pulled into the import graph. This file
// is the entry for the metrological store bundle, so the patches cannot live only in boot.js.
import './modules/polyfills/install';

import { Launch } from '@lightningjs/sdk';
import Store from 'lightningjs-redux';
import App from './modules/app/platform/default/app.component';
import { setup } from './modules/polyfills';
import { initStore } from './store';
import { getSettings } from './modules/settings/app.settings';

setup(window);

const appLauncher = function AppLauncher(appSettings, platformSettings, appStoreData) {
  const settings = getSettings(appSettings, platformSettings);

  Store.init(initStore());

  return Launch(App, settings.appSettings, settings.platformSettings, appStoreData || {});
};

// mimic Lightning pre-build app launcher
if (process.env.APP_ID) {
  const id = 'APP_'.concat(process.env.APP_ID.replace(/[^0-9a-zA-Z_$]/g, '_'));
  window[id] = appLauncher;
}

export default appLauncher;
